import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, OnChanges, SimpleChanges } from "@angular/core";
import { FilterBayService } from "src/app/services/filter-bay.service";

@Component({
  selector: "app-filter-bay-reusable",
  templateUrl: "./filter-bay-reusable.component.html",
  styleUrls: ["./filter-bay-reusable.component.scss"],
})
export class FilterBayReusableComponent implements OnInit, OnChanges {
  @Input() addFilters;
  @Input() MaterialMaster:boolean=false;
  @Output() getChildChanges = new EventEmitter<boolean>();
  filtersLength;
  detectChanges: boolean;
  constructor(private filterBayService: FilterBayService) {}
  ngOnInit(): void {
    this.updateFiltersLength();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['addFilters']) {
      this.updateFiltersLength();
    }
  }

  updateFiltersLength(): void {
    this.filtersLength = this.addFilters ? Object.keys(this.addFilters).length : 0;
  }

  formatFilterValue(value: any): string {
    if (Array.isArray(value)) {
      return value.join(',');
    }
    return value;
  }

  removeFilters(key) {
    if(this.MaterialMaster){
       this.filterBayService.setFiltersForMaterialMaster(key);
       return
    }
    this.filterBayService.setFilters(key);
  }
}
